<template>
    <div class="page-content header-clear-medium">

		<div v-if="loading">		
			<NewsSekeleton :count="1" :textCount="10" />
		</div>
		<div v-else>
			<div class="card card-style">
				<div class="content mt-2">
					<!-- <a class="col" data-gallery="gallery-2" href="images/pictures/7t.jpg" title="Portrait">
						<img src="images/empty.png" data-src="images/pictures/7t.jpg" class="preload-img img-fluid rounded-l" alt="img">
					</a> -->
					<!-- <a :href="item.image" title="Caption Title" class="card card-style bg-14 mb-3 mx-0" style="height:400px" data-gallery="gallery-3" :style="{ 'background-image': 'url('+item.image+')', 'object-fit': 'fill' }"> -->
					<div title="Caption Title" class="card card-style bg-14 mb-3 mx-0" style="height:400px" data-gallery="gallery-3" :style="{ 'background-image': 'url('+post_single._embedded['wp:featuredmedia'][0]['source_url']+')', 'object-fit': 'fill' }">					
					</div>
					
					<h5 class="color-highlight font-14 mb-1">{{ post_single.date | getDateIndo }}</h5>
					<h3 v-html="post_single.title.rendered"></h3>
					<div class="d-flex mb-2">
						<div class="d-flex flex-row">
							<i class="bi bi-person-circle color-blue-dark font-16"></i>
							<p class="font-16 ms-2"><strong>Berita</strong></p>
						</div>
						<!-- <div class="d-flex flex-row ms-3">
							<i class="bi bi-eye-fill color-blue-dark font-16"></i>
							<p class="font-16 ms-2"><strong>{{ post_single.count_read }}</strong></p>
						</div> -->
					</div>
					
					<div class="mb-3" v-html="post_single.content.rendered"></div>

					<!-- <div>
						<a 
							v-for="itemTag in post_single.tags" :key="itemTag.id"
							href="#" 
							class="btn-xxs btn border-blue-dark color-blue-dark me-1"
						>{{ itemTag.name }}</a>
					</div> -->
				</div>
			</div>
		</div>
        
    </div>
</template>

<script>
import { 
	mapMutations, 
	mapActions, mapState 
} from 'vuex'

import NewsSekeleton from "../components/skeleton/NewsSekeleton.vue";

export default {
    name: 'News',
    components: {
		NewsSekeleton
    },
    data() {
        return {
			
        }
    },
    async created() {
		this.SET_LOADING()
		const data = await this.getPostSingle(this.$route.params.slug)
		await this.readPostNotificaion(data.id);
		this.CLEAR_LOADING()	
		// await this.getPostSingleRead(this.$route.params.slug)
    },
    methods: {
        ...mapMutations(['SET_LOADING', 'CLEAR_LOADING']),
        ...mapActions('postWp', ['getPostSingle']),
		...mapActions('notificationLocal', ['readPostNotificaion']),
    },
    computed: {
        ...mapState({
            loading: state => state.loading
        }),
        ...mapState('postWp', {
			post_single: state => state.post_single,
        }),
    }
}
</script>

<style scoped>
.cursor-pointer { cursor: pointer; }
</style>
